export const gridSize = {
    mobile: {
        gap: "8px",
        margin: "16px",
    },
    tablet: {
        gap: "12px",
        margin: `${(32 / 768) * 100}%`,
    },
    desktop: {
        gap: "16px",
        margin: `${(32 / 1440) * 100}%`,
    },
} as const;
